import { createIcon } from './icon-utils';

export const DoneAllIcon = createIcon({
  path: 'M7.65781 18.3922L2.00781 12.7422L3.43281 11.3422L9.08281 16.9922L7.65781 18.3922ZM13.3078 18.3922L7.65781 12.7422L9.05781 11.3172L13.3078 15.5672L22.5078 6.36719L23.9078 7.79219L13.3078 18.3922ZM13.3078 12.7422L11.8828 11.3422L16.8328 6.39219L18.2578 7.79219L13.3078 12.7422Z',
});
